import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Application } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-pap-application-verification',
  templateUrl: 'pap-application-verification.component.html',
  styleUrls: ['./pap-application-verification.component.less', '../../../shared/common.less'],
})

export class PapApplicationVerificationComponent implements OnInit {
  @Input() application: Application;
  @Input() isExpanded: boolean = false;
  @Output() applicationChange = new EventEmitter<Application>();
  @Output() validated = new EventEmitter<boolean>();
  @Output() editRequested = new EventEmitter<void>();

  needPap: boolean = undefined;
  minDate: string;
  hasMailOption: boolean = false;
  hasEMailOption: boolean = false;
  hasHandOption: boolean = false;
  isValidated: boolean = false;

  constructor(
  ) {
    const today = new Date();
    this.minDate = today.toISOString().substring(0, 10);
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

  onValidate() {
    this.isExpanded = false;
    this.isValidated = true;
    this.validated.emit(true);
  }

  onEdit() {
    this.editRequested.emit();
  }

  onPeriodChange() {
    this.applicationChange.emit(this.application);
  }

  get firstRoundLimitString(): string {
    return this.application.firstRoundLimit
      ? this.application.firstRoundLimit.toISOString().substring(0, 10)
      : '';
  }

  set firstRoundLimitString(value: string) {
    if (value) {
      if (!this.application.firstRoundLimit) {
        this.application.firstRoundLimit = new Date(value);
      } else {
        const currentTime = this.application.firstRoundLimit;
        const newDate = new Date(value);
        newDate.setHours(currentTime.getHours(), currentTime.getMinutes(), 0, 0);
        this.application.firstRoundLimit = newDate;
      }
    } else {
      this.application.firstRoundLimit = null;
    }
    this.onPeriodChange();
  }

  get firstRoundLimitTime(): string {
    if (!this.application.firstRoundLimit) return '';
    const hours = this.application.firstRoundLimit.getHours().toString().padStart(2, '0');
    const minutes = this.application.firstRoundLimit.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  set firstRoundLimitTime(value: string) {
    if (!this.application.firstRoundLimit) {
      this.application.firstRoundLimit = new Date();
    }
    const [hours, minutes] = value.split(':').map(Number);
    this.application.firstRoundLimit.setHours(hours, minutes, 0, 0);
    this.onPeriodChange();
  }

  get secondRoundLimitString(): string {
    return this.application.secondRoundLimit
      ? this.application.secondRoundLimit.toISOString().substring(0, 10)
      : '';
  }

  set secondRoundLimitString(value: string) {
    if (value) {
      if (!this.application.secondRoundLimit) {
        this.application.secondRoundLimit = new Date(value);
      } else {
        const currentTime = this.application.secondRoundLimit;
        const newDate = new Date(value);
        newDate.setHours(currentTime.getHours(), currentTime.getMinutes(), 0, 0);
        this.application.secondRoundLimit = newDate;
      }
    } else {
      this.application.secondRoundLimit = null;
    }
    this.onPeriodChange();
  }

  get secondRoundLimitTime(): string {
    if (!this.application.secondRoundLimit) return '';
    const hours = this.application.secondRoundLimit.getHours().toString().padStart(2, '0');
    const minutes = this.application.secondRoundLimit.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  set secondRoundLimitTime(value: string) {
    if (!this.application.secondRoundLimit) {
      this.application.secondRoundLimit = new Date();
    }
    const [hours, minutes] = value.split(':').map(Number);
    this.application.secondRoundLimit.setHours(hours, minutes, 0, 0);
    this.onPeriodChange();
  }

  ngOnChanges(): void {
    
  }
  
  ngOnInit(): void {
  }
}
